import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {

  loadingSub: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  
  
  /**
   * Contains in-progress loading requests
  */
 loadingMap: Map<string, boolean> = new Map<string, boolean>();
 private _isSearchApiCall:boolean = true;
  
  constructor() { }

  get loadingSub$(): Observable<boolean> {
    return this.loadingSub.asObservable();
  }

  setLoading(loading: boolean, url: string) {
    if (!url) {
      throw new Error('The request URL must be provided to the LoadingService.setLoading function');
    }
    if (loading === true) {
      this.loadingMap.set(url, loading);
      this.loadingSub.next(true);
    }else if (loading === false && this.loadingMap.has(url)) {
      this.loadingMap.delete(url);
    }
    if (this.loadingMap.size === 0) {
      this.loadingSub.next(false);
    }
  }

  setIsSearchApiCall(isSearch: boolean){
    this._isSearchApiCall = isSearch;
  }

  get isSearchApiCall(){
    return this._isSearchApiCall;
  }


}
